import { render } from "./Taxonomy.vue?vue&type=template&id=4a3c013c"
import script from "./Taxonomy.vue?vue&type=script&lang=js"
export * from "./Taxonomy.vue?vue&type=script&lang=js"
script.render = render

export default script